import type { Dispatch, FC, SetStateAction } from 'react'
import { CwsButton, CwsGridCol, CwsGridRow, CwsH3, CwsP } from '@components/cws'
import s from '@components/support/Returns/Return.module.scss'
import { useTranslate } from '@hooks/useTranslation'

interface ReturnsCart {
  setVisibleModal: Dispatch<SetStateAction<boolean>>
}
export const ReturnsCart: FC<ReturnsCart> = ({ setVisibleModal }) => {
  const { translate } = useTranslate()
  return (
    <CwsGridRow noGutter>
      <CwsGridCol col="fluid">
        <div className={s.returnCard}>
          <CwsH3>{translate('w2.feedback.return.card.title')}</CwsH3>

          <div>
            <CwsP>{translate('cart.confirmation.vendor.email.label')}:</CwsP>
            <CwsP>{translate('cart.confirmation.vendor.email.value')}</CwsP>
          </div>

          <CwsButton data-modal-id="feedback-modal" onClick={() => setVisibleModal(true)} width="fluid">
            {translate('w2.support.return.item')}
          </CwsButton>
        </div>
      </CwsGridCol>
    </CwsGridRow>
  )
}
